module.exports = __webpack_public_path__ + "static/media/IconUserPolisiOffline.bc666606.svg";